// eslint-disable-next-line no-unused-expressions
import('./ASCIIMath2Tex');
